import { ValueOf } from 'lib/core/types';

import { TaskAction } from 'lib/common/contexts/ContactContext/constants/taskAction';
import getTaskType from 'lib/common/contexts/ContactContext/utils/getTaskType';
import taskBuilder from 'lib/common/contexts/ContactContext/utils/taskBuilder/index';
import { THasPermission } from 'lib/common/contexts/PermissionsContext/Provider';

import CONTACT_STATES from 'lib/common/constants/contactStates';
import CONTACT_TYPE from 'lib/common/constants/contactTypes';

export default async function newTask({
  contact,
  status,
  hasPermission,
}: {
  contact?: connect.Contact;
  status?: ValueOf<typeof CONTACT_STATES>;
  hasPermission: THasPermission;
}) {
  if (!contact) {
    return null;
  }

  const taskType = getTaskType(contact);

  if (!taskType) {
    return null;
  }

  if (taskType === CONTACT_TYPE.CHAT) {
    const newChatTask = await taskBuilder.newChatTask({
      hasPermission,
      contact,
      status,
    });

    if (!newChatTask) {
      return null;
    }

    return { task: newChatTask, action: TaskAction.CREATE };
  }

  if (taskType === 'PREVIEW_DIALING') {
    const newPreviewDialingTask = await taskBuilder.newPreviewDialingTask({
      contact,
      status,
    });

    if (!newPreviewDialingTask) {
      return null;
    }

    return { task: newPreviewDialingTask, action: TaskAction.CREATE };
  }

  const baseTask = taskBuilder.newBaseTask(contact, status);

  if (!baseTask) {
    return null;
  }

  return { task: baseTask, action: TaskAction.CREATE };
}
